// 担当者別取引日計表 API クライアント

import { FileClient } from "../RestClient";

export type B110030Request = Partial<{
  denpyoYmdFrom: string;
  denpyoYmdTo: string;
  eigyoCdFrom: string;
  eigyoCdTo: string;
  bumonCdFrom: string;
  bumonCdTo: string;
  shainCdFrom: string;
  shainCdTo: string;
  shokaKbn: string;
  outputType: string;
}>;

export const B110030GetExcel = async (props: B110030Request) => {
  return FileClient.get("b110030/get/excel", { params: props });
};
